import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Building2, LogIn } from "lucide-react";
import { ensureDemoSeed, partnerLogin } from "@/lib/partner/partnerAccounts";
import { toast } from "sonner";

export const Route = createFileRoute("/partners/login")({
  head: () => ({
    meta: [
      { title: "Partner Login · VerseSport" },
      { name: "description", content: "Acceso para socios corporativos aprobados." },
    ],
  }),
  component: PartnerLoginPage,
});

function PartnerLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  useEffect(() => { ensureDemoSeed(); }, []);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const session = partnerLogin(email.trim(), password.trim());
    if (!session) { toast.error("Credenciales inválidas o cuenta no aprobada"); return; }
    toast.success(`Bienvenido, ${session.company_name}`);
    nav({ to: "/tenant-portal", search: { tenant: session.tenant_id ?? undefined } });
  };
  return (
    <div className="mx-auto max-w-md px-4 py-12">
      <div className="mb-6 flex items-center gap-2 text-sm font-black uppercase tracking-widest text-primary">
        <Building2 className="h-4 w-4" /> Partner Login
      </div>
      <h1 className="mb-2 text-2xl font-black">Acceso Corporativo</h1>
      <p className="mb-6 text-xs text-muted-foreground">
        Acceso restringido a partners aprobados por el equipo enterprise.
      </p>
      <form onSubmit={submit} className="space-y-3 rounded-2xl border border-border bg-background/60 p-5">
        <label className="block text-xs font-bold">Corporate Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm" placeholder="you@company.com" />
        </label>
        <label className="block text-xs font-bold">Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm" />
        </label>
        <button type="submit" className="flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-black text-primary-foreground">
          <LogIn className="h-4 w-4" /> Entrar
        </button>
      </form>
      <p className="mt-4 text-xs text-muted-foreground">
        ¿Sin cuenta? <Link to="/partners/register" className="text-primary underline">Solicitar acceso</Link>
      </p>
    </div>
  );
}